module.exports = __webpack_public_path__ + "img/async_recall.aeeb94f8.png";